import api from "./api";

export const pricingStockService = {
  getSalesCatalog(params) {
    return api.get("/pricing/catalog", { params });
  },

  getSalesCatalogExport(params) {
    return api.get("/pricing/catalog/export-data", { params });
  },

  getSalesCatalogSuggest(params) {
    return api.get("/pricing/catalog/suggest", { params });
  },

  getEffectivePrice(params) {
    return api.get("/pricing/effective", { params });
  },

  previewBulkUpdate(payload) {
    return api.post("/pricing/updates/preview", payload);
  },

  applyBulkUpdate(payload) {
    return api.post("/pricing/updates/apply", payload);
  },

  previewByProvider(payload) {
    return api.post("/pricing/updates/by-provider", payload);
  },

  updateByField(payload) {
    return api.post("/pricing/updates/by-field", payload);
  },

  upsertMemberships(payload) {
    return api.post("/pricing/memberships/upsert", payload);
  },

  getMemberships(params) {
    return api.get("/pricing/memberships", { params });
  },

  upsertProviderLinks(payload) {
    return api.post("/pricing/providers/upsert-links", payload);
  },

  getProviderLinks(params) {
    return api.get("/pricing/providers/links", { params });
  },

  getProviders(params) {
    return api.get("/pricing/providers", { params });
  },

  getProviderRubros(providerId, params) {
    return api.get(`/pricing/providers/${providerId}/rubros`, { params });
  },

  getRubrosCatalog(params) {
    return api.get("/pricing/rubros", { params });
  },

  createProvider(payload) {
    return api.post("/pricing/providers", payload);
  },

  updateProvider(id, payload) {
    return api.put(`/pricing/providers/${id}`, payload);
  },

  getPriceFormulas(params) {
    return api.get("/pricing/formulas", { params });
  },

  getBonuses(params) {
    return api.get("/pricing/bonuses", { params });
  },

  upsertBonuses(payload) {
    return api.post("/pricing/bonuses/upsert", payload);
  },

  createPriceFormula(payload) {
    return api.post("/pricing/formulas", payload);
  },

  updatePriceFormula(id, payload) {
    return api.put(`/pricing/formulas/${id}`, payload);
  },

  bulkStockQuery(payload) {
    return api.post("/stock/query/bulk", payload);
  },

  bulkStockAdjust(payload) {
    return api.post("/stock/adjustments/bulk", payload);
  },

  getStockMovements(params) {
    return api.get("/stock/movements", { params });
  },

  getAuditLogs(params) {
    return api.get("/audit/logs", { params });
  },

  getReportOverview(params) {
    return api.get("/pricing/reports/overview", { params });
  },

  getReportTrend(params) {
    return api.get("/pricing/reports/trend", { params });
  },

  getReportByProvider(params) {
    return api.get("/pricing/reports/by-provider", { params });
  },

  getReportTopChanges(params) {
    return api.get("/pricing/reports/top-changes", { params });
  },
};
